import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectVendorData } from 'store/vendorSlice/selectors';
import oveitLogo from '../../../assets/common/oveit-logo.svg';

const LogoWrapper: React.FC<{}> = () => {
  const {
    id: vendorId,
    features,
    publicInformation,
  } = useSelector(selectVendorData);

  const vendorEventsPageLink = `/org/${vendorId}`;

  const logoToDisplay = features?.hasMarketplaceCustomLogo
    ? publicInformation.avatar
    : oveitLogo;

  const logoContainerClasses = 'h-[40px] w-[90px] md:h-[56px] md:w-[120px]';

  const logoElement = (
    <div
      className={`${logoContainerClasses} bg-contain bg-left bg-no-repeat`}
      style={{ backgroundImage: `url(${logoToDisplay})` }}
    />
  );

  return vendorId ? (
    <Link to={vendorEventsPageLink} className="block h-full w-fit">
      {logoElement}
    </Link>
  ) : (
    logoElement
  );
};

export default LogoWrapper;
